import { hakoLibVuePlugin } from '@hakosalo/hakolib'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from "pinia";
import { useAuthStore, hakosaloAuth } from "@hakosalo/client-auth";
import { useUserStore } from './stores/userStore';
import axios from 'axios';
import userhelpers from './helpers';
import { config } from "@hakosalo/hakolib";

config.language = "fi";

function setAxiosDefaults() {
	axios.defaults.baseURL = process.env["VUE_APP_API"];
	// axios.defaults.withCredentials = true;
	const session = hakosaloAuth.getSessionFromLocalStorage();
	if (session) {
		axios.defaults.headers["Authorization"] = hakosaloAuth.generateAuthorizationHeaderValue(session);
	}
}

setAxiosDefaults();

const pinia = createPinia();
hakosaloAuth.setPinia(pinia);
hakosaloAuth.setBaseUrl(process.env["VUE_APP_LOGINSERVICE_API"]);

const app = createApp(App)
	.use(router)
	.use(hakoLibVuePlugin)
	.use(userhelpers)
	.use(pinia);

(async () => {
	await hakosaloAuth.onStartAsync();

	if (!useAuthStore().isLoggedIn) {
		window.location.replace(
			`${process.env["VUE_APP_LOGINSERVICE"]}?redirect_url=` +
				encodeURIComponent(window.location.href)
		);
	} else {
		// Application starting point
		setAxiosDefaults();
		await useUserStore().getCurrentUser();
		app.mount("#app");
	}
})();

